import React, { useCallback, useEffect, useRef, useState } from 'react';
import Loading, { useLoading } from "../Chat/Loading";
import ModalWindow from "../Chat/Modal";
import { useChatStoreReducer } from "./store";
import { FlexScroll, Grid, TagInputContainer } from "./styles";
import { Button, Icon, TagInput, Dropdown, CheckBox} from "@dspworkplace/ui";
import { FilterTagArrayType } from "../Chat/types";
import styled from "styled-components";
// import lang from "bad-words/lib/lang.json";
import { setBadWords } from "./utils";
import { engine, getCompanyId, setChatCompanyId, setChatUserId, getUserId, setChatTeam, setStreamChatIdentifier, getStreamChatIdentifier, setImpersonateStreamChatIdentifier, getImpersonateStreamChatIdentifier, setIsOpenChat, showToast, setChatUserRole, setIsEnableSMS } from "../Utilities";
import { Combobox } from '../components/Form/Combobox';


const Row = styled.div`
    display: grid;
    align-items: center;
    justify-content: flex-start;
    grid-column-gap: 16px;
    grid-template-columns: repeat(5, 118px);
    grid-row-gap: 8px;
`;

const WordContainer = styled.div`
    display: flex;
    box-sizing: border-box;
    border: 1px solid #7C98B6;
    background: #EAF0F6;
    border-radius: 2px;
    padding: 0 8px;
    height: 24px;
    align-items: center;
    color: #516F90;
    font-size: 12px;
    font-weight: 600;
    flex-direction: row;
    justify-content: space-between;

    div.smallFont {
        font-size: 8px;
    }

    div.iconContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
            box-shadow: 0 0 6px #0071BC;
            border-radius: 2px;
        }
    }
`;

const AddRow = styled.div`
    height: 40px;
    width: 100%;
    color: #333;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    input {
        font-family: circe-rounded, serif;
        display: flex;
        box-sizing: border-box;
        width: 300px;
        border-radius: 4px;
        border: 1px solid #EAF0F6;
        font-size: 16px;
        height: 40px;
        margin-right: 16px;
    }
`;

function ImpersonateModal() {
    const { state, dispatch } = useChatStoreReducer();
    const { loading, setLoading } = useLoading();
    // @ts-ignore
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [allUsers, setAllUsers] = useState([]);
    const [allCompanyUsers, setAllCompanyUsers] = useState([]);
    const [allCompany, setAllCompany] = useState([]);
    const [terminatedEmployees, setTerminatedEmployees] = useState(false);
    let employeeStatusArr = [
        {value: '-2', name: 'Terminated'},
        {value: '-1', name: 'Offboarded'},
        {value: '0', name: 'Inactive'},
        {value: '1', name: 'Onboarding'},
        {value: '2', name: 'Active'},
    ];
    const ref = useRef(null)
    const closeModal = useCallback(
        () => {
            dispatch({ type: "CLOSE_IMPERSONATE_MODAL" });
        },
        [dispatch],
    );

    const changeUser = async (e) => {
        if (e?.value) {
            if (!getImpersonateStreamChatIdentifier()) {
                await setImpersonateStreamChatIdentifier(getStreamChatIdentifier());
            }
            await setChatTeam('company-' + selectedCompanyId);
            await setChatUserId(e?.value?.id);
            await setChatCompanyId(selectedCompanyId);
            await setStreamChatIdentifier(e?.value?.streamChatIdentifier);
            await setChatUserRole(e?.value?.roleName)
            if (window.location.pathname === "/chat")
                setIsOpenChat(false)
            else
                setIsOpenChat(true);
            window.location.reload();
        }
    }
    const getAllCompany = async () => {
        if (getUserId() === 1560 || getUserId() === 2696) {
            const companyParams = {
                actions: {
                    response: {
                        Company: {
                            findBy: {
                                criteria: {},
                                get: "company",
                                includes: {
                                    0: "id",
                                    1: "name",
                                },
                                orderBy: {
                                    name: "ASC"
                                }
                            }
                        }
                    }
                }
            };

            let response = await engine().post("/api/lazy/manage/data", companyParams).then(result => {
                if (result) {
                    try {
                        setAllCompany(result.data.data.company);
                        setLoading(false);
                    } catch (e) {
                        console.error({ e });
                    }
                }
            });
        } else {
            setSelectedCompanyId(getCompanyId());
        }

    };
    const getAllEmployees = async () => {
        const params = {
            actions: {
                response: {
                    "User": {
                        "custom": {
                            "functionName": "getImpersonateChatUser",
                            "get": "user",
                            "criteria": {
                                "company": selectedCompanyId
                            },
                            "excludes": {},
                            "includes": {}
                        }
                    },
                    "Company": {
                        "custom": {
                            "functionName": "getSmsPermission",
                            "get": "getSmsPermission",
                            "criteria": {
                                "company": selectedCompanyId
                            },
                            "excludes": {},
                            "includes": {}
                        }
                    }
                },

            },
        };

        if (selectedCompanyId) {
            let response = await engine().post("/api/lazy/manage/data", params).then(async result => {
                if (result) {
                    try {
                        setAllUsers([]);
                        const users = await result.data.data.user;
                        let filterUser = await users.filter(i => (i?.streamChatIdentifier !== null || i?.streamChatIdentifier !== undefined));
                        setAllCompanyUsers(filterUser);
                        if(terminatedEmployees) {
                            let terminated = filterUser.filter(i => (i?.employeeStatus === '-2'));
                            filterUser = terminated;
                        }
                        setAllUsers(filterUser);
                        setIsEnableSMS(result.data.data.getSmsPermission);
                        setLoading(false);
                    } catch (e) {
                        console.error({ e });
                    }
                }
            });
        }
    };

    const handleOnlyTerminated = (terminated) => {
        if(terminated) {
            setTerminatedEmployees(true);
            const filterUser = allCompanyUsers.filter(i => (i?.employeeStatus === '-2'));
            setAllUsers(filterUser);
        } else {
            setTerminatedEmployees(false);
            setAllUsers(allCompanyUsers);
        } 
    }

    useEffect(() => {
        getAllEmployees();
    }, [selectedCompanyId]);

    useEffect(() => {
        try {
            setLoading(true);
            getAllCompany();
        } catch (e) {
            console.error({ e, name: 'ImpersonateModal()' });
        }

    }, []);

    if (!state.impersonateModal) {
        return null;
    }

    if (loading) {
        return (
            <ModalWindow minHeight={"unset"} width={"500px"} title={"Impersonate Chat"} cancelModal={closeModal} cancelText={"Close"}>
                <Loading containerHeight={"70px"} containerWidth={"100%"} imgHeight={"50px"} />
            </ModalWindow>
        );
    }

    return (
        <ModalWindow minHeight={"unset"} width={"500px"} title={"Impersonate Chat"} cancelModal={closeModal} cancelText={"Close"} overflowX={"unset"}>
            {/* <Grid justifyContent='space-between' rowGap={"16px"} style={{paddingBottom: "120px;"}}> */}
            {/* <AddRow> */}
            <div style={{}}>
                {(getUserId() === 1560 || getUserId() === 2696) &&
                    <Combobox
                        ref={ref}
                        size={'full'}
                        options={allCompany.map((c) => { return { label: c.name, value: c.id } })}
                        placeholder={'All Company'}
                        onChange={(e) => { setSelectedCompanyId(e.value); }}
                        isAdd={false}
                        optionStyle={{ 'overflowX': 'auto', 'maxHeight': '300px' }}
                    />
                }
            </div>
            <div style={{}}>
                <CheckBox
                    name='terminatedEmployees'
                    options={[
                        { value: true, label: 'Only Terminated' }
                    ]}
                    defaultValues={[terminatedEmployees]}
                    onClick={(e) => { handleOnlyTerminated(e.target.checked); }}
                />
            </div>
            <div style={{}}>
                <Combobox
                    ref={ref}
                    size={'full'}
                    options={allUsers.map((u) => { 
                        let status = employeeStatusArr.find((s) => s.value === u?.employeeStatus); 
                        return { label: `${u?.friendlyName} (${u?.roleName}) - (${status.name})`, value: u } 
                    })}
                    placeholder={'All Employees'}
                    onChange={(e) => changeUser(e)}
                    isAdd={false}
                    optionStyle={{ 'overflowX': 'auto', 'maxHeight': '300px' }}
                />
            </div>
            {/* </AddRow> */}
            {/* </Grid> */}
        </ModalWindow>
    );
}

function ImpersonateModalContainer() {
    const { state } = useChatStoreReducer();
    if (!state.impersonateModal) {
        return null;
    }
    return <ImpersonateModal />
}

export default ImpersonateModalContainer;